export default "__VITE_ASSET__DvKCq6eZ__"